import { Product } from "./types";

export const REQUIRED_PRODUCTS: Product[] = [
  "NEGPOS_00_04",
  "NEGPOS_04_08",
  "NEGPOS_08_12",
  "NEGPOS_12_16",
  "NEGPOS_16_20",
  "NEGPOS_20_24",
];

export const CHART_HEIGHT = 400;
